module.exports = __webpack_public_path__ + "prj_06.c39e01d9.jpeg";